import * as React from 'react';
import styles from './EditTip.module.scss';
import { connect } from 'react-redux';

import { Button } from '../Button/Button';
import { useState } from 'react';
import classnames from 'classnames';
import { ConfirmationDialog } from '../ConfirmationModal/ConfirmationDialog';
import { postEvent } from '../../api/tracking';
//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store';
import { userSelector } from '../../store/login/selector';
import { User } from '@sentry/types';
import { MatchFromBE, UnlockedTipData } from '../../store/tips/reducer';
import { useAnalyticsHandlers } from '../../analytics/__providers__/AnalyticsHandlersProvider';

export interface OwnProps {
  selectedBet: UnlockedTipData;
  betEditRequest: any;
  selectBet: (values: any) => any;
  refreshBets: (values: boolean) => any;
  allMatches: MatchFromBE[];
}
export interface StateProps {
  user: User;
}

export const EditTip: React.FC<OwnProps & StateProps> = ({
  allMatches,
  selectedBet,
  user,
  betEditRequest,
  selectBet,
  refreshBets,
  ...props
}) => {
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [optionsOpen, setOptionsOpen] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const analytics = useAnalyticsHandlers();

  const userId: string = (user.id as string) || '';
  const cx = classnames.bind(styles);

  const handleSubmit = (data: any) => {
    setSubmitting(true);

    const formatted = { match_forecast_results: { ...data } };
    const { match_forecast_results } = formatted;
    betEditRequest({ match_forecast_results, id: selectedBet.id }).then(
      (res: any) => {
        analytics?.client.Mixpanel.log('CLOSED_TIP_WEB', [
          {
            tip_id: res.tip.id,
            tip_result: res.tip.result,
          },
        ]);

        postEvent('CLOSED_TIP_WEB', userId, {
          tip_id: selectedBet.id,
        });
        if (res && res.tip && res.tip.finished_at) {
          selectBet(null);
          refreshBets(true);
          setSubmitting(false);
        } else {
          selectBet(null);
          refreshBets(false);
          setSubmitting(false);
        }
      },
    );
  };
  const validateForm = () => {
    if (Object.keys(data)[0] === 'null') {
      return false;
    } else if (
      Object.keys(data).length === selectedBet.match_forecasts.length
    ) {
      return false;
    } else return true;
  };

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.container}>
        <button onClick={() => selectBet(null)} className={styles.button}>
          {tr(t, 'back')}
        </button>
        <h1>{tr(t, 'tip_correct')}</h1>
        <div className={styles.wrapper}>
          {selectedBet.match_forecasts.map((forecast, index) => {
            const matchData: MatchFromBE | undefined = allMatches.find(
              (m) => m.id === forecast.match_id,
            );

            return (
              matchData && (
                <div key={matchData.id || index} className={styles.matchInfo}>
                  <div className={styles.matchInfoHeader}>
                    <div>
                      <label>{matchData.name}</label>
                      {' - '}
                      <label style={{ fontWeight: 'bold' }}>
                        {forecast.pick}
                      </label>

                      <p className={styles.market}>
                        {t(
                          `markets:bet_markets_${forecast.market_code}`,
                        ).replace('bet_markets_', '')}
                      </p>

                      <label>
                        <span style={{ textTransform: 'capitalize' }}>
                          {matchData.sport}
                        </span>
                        {' - '}
                        <span>{matchData.country}</span>{' '}
                        <span>{matchData.competition_name}</span>
                      </label>
                    </div>
                    <div>
                      <div>
                        <label>Stake</label>
                        <p>{selectedBet.stake}u</p>
                      </div>
                      <div>
                        <label>{tr(t, 'odd')}</label>
                        <p>{forecast.rate}</p>
                      </div>
                      <div>
                        <label>Bookie</label>
                        <p>{selectedBet.bookie}</p>
                      </div>
                    </div>
                  </div>

                  <div className={styles.formContainer}>
                    <div className={styles.editRadioGroupContainer}>
                      <div>
                        <div
                          className={
                            //@ts-ignore
                            data[forecast.id] === 'WON'
                              ? styles.activeWONBetEditRadioContainer
                              : styles.betEditRadioContainer
                          }
                          onClick={() => {
                            setData({ ...data, [forecast.id]: 'WON' });
                          }}
                        >
                          <label>{tr(t, 'WON')}</label>
                        </div>
                        <div
                          className={
                            //@ts-ignore
                            data[forecast.id] === 'VOID'
                              ? styles.activeBetEditRadioContainer
                              : styles.betEditRadioContainer
                          }
                          onClick={() => {
                            setData({ ...data, [forecast.id]: 'VOID' });
                          }}
                        >
                          <label>{tr(t, 'VOID')}</label>
                        </div>
                        <div
                          className={
                            //@ts-ignore
                            data[forecast.id] === 'LOST'
                              ? styles.activeLOSTBetEditRadioContainer
                              : styles.betEditRadioContainer
                          }
                          onClick={() => {
                            setData({ ...data, [forecast.id]: 'LOST' });
                          }}
                        >
                          <label>{tr(t, 'LOST')}</label>
                        </div>
                      </div>
                      <div>
                        {!optionsOpen ? (
                          <div
                            className={cx(
                              styles.betEditRadioContainer,
                              styles.wide,
                            )}
                            onClick={() => setOptionsOpen(true)}
                          >
                            <label>{tr(t, 'other-results')}</label>
                          </div>
                        ) : (
                          <>
                            <div
                              className={
                                //@ts-ignore
                                data[forecast.id] === 'HALF_WON'
                                  ? styles.activeBetEditRadioContainer
                                  : styles.betEditRadioContainer
                              }
                              onClick={() => {
                                setData({ ...data, [forecast.id]: 'HALF_WON' });
                              }}
                            >
                              <label>{tr(t, 'HALF_WON')}</label>
                            </div>
                            <div
                              className={
                                //@ts-ignore
                                data[forecast.id] === 'CANCELED'
                                  ? styles.activeBetEditRadioContainer
                                  : styles.betEditRadioContainer
                              }
                              onClick={() => {
                                setData({ ...data, [forecast.id]: 'CANCELED' });
                              }}
                            >
                              <label>{tr(t, 'CANCELED')}</label>
                            </div>
                            <div
                              className={
                                //@ts-ignore
                                data[forecast.id] === 'HALF_LOST'
                                  ? styles.activeBetEditRadioContainer
                                  : styles.betEditRadioContainer
                              }
                              onClick={() => {
                                setData({
                                  ...data,
                                  [forecast.id]: 'HALF_LOST',
                                });
                              }}
                            >
                              <label>{tr(t, 'HALF_LOST')}</label>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )
            );
          })}
        </div>
        <div className={styles.submitBtn}>
          <Button
            theme={'primary'}
            type={'submit'}
            disabled={validateForm() || submitting}
            action={() => {
              setOpen(true);
            }}
            className={styles.button}
          >
            {tr(t, 'close-tip')}
          </Button>
          <ConfirmationDialog
            variant={'danger'}
            title={tr(t, 'confirm')}
            open={open}
            onSubmit={() => {
              setOpen(false);
              handleSubmit(data);
            }}
            onClose={() => setOpen(false)}
            confirmationText={tr(t, 'close-tip')}
            cancelText={tr(t, 'cancel')}
          >
            <div className={styles.confirmationTable}>
              {selectedBet.match_forecasts.map((match, index) => {
                return (
                  <div key={match.id || index}>
                    <div>{match.pick}</div>
                    <div>{match.market}</div>
                    <div
                      className={
                        //@ts-ignore
                        data[match.id] === 'WON'
                          ? styles.WONBetEditRadioContainer
                          : //@ts-ignore
                          data[match.id] === 'LOST'
                          ? styles.LOSTBetEditRadioContainer
                          : ''
                      }
                    >
                      {/*@ts-ignore */}
                      {tr(t, data[match.id])}
                    </div>
                  </div>
                );
              })}
            </div>
          </ConfirmationDialog>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
});

export const EditTipConnected = connect(mapStateToProps)(EditTip);
